var App = App || {};

App.SharedFormValidation = (function ($) {
    'use strict';

    function Init(form) {
        Load(form);
        Submit(form)
    }

    function Load(form) {
        form.find("[data-zag-validate-input]").on("input", function () { Input($(this)); });
    }

    function Submit(form) {

        // remove kentico's update and onsubmit functions
        var kenticoSubmit = form.attr("onsubmit") || "",
            kenticoUpdate = form.attr("data-ktc-ajax-update") || "";

        form.removeAttr("onsubmit data-ktc-ajax-update").on("submit", function (e) {

            e.preventDefault();
            form.attr("data-zag-validate-form", "submitted");

            // different validation tactics
            form.find("[data-zag-validate-input]").each(function () { Input($(this)); });

            // if there are no error messages, submit the form
            if (form.find("[data-zag-validate-field=\"error\"]").length > 0) {
                form.find("[data-zag-validate-field=\"error\"]")
                    .first()
                    .find("[data-zag-validate-input]")
                    .first()
                    .trigger("focus");
            }
            else {
                if (kenticoSubmit !== "" && kenticoUpdate !== "") {
                    //replace kentico's onsubmit, etc. function from attribute list
                    $(this).attr({ "onsubmit": kenticoSubmit, "data-ktc-ajax-update": kenticoUpdate });
                    // and allow it to submit
                    $(this).off("submit").submit().find("input[type='submit']").prop("disabled", "true");

                    // The user may have had to scroll through the form to fill it out. If so, they may not see the top of the form any longer, which
                    // means they also won't see the "thank you" note to indicate their submission was successful. Scroll up so they see it.
                    $("html, body").animate({
                        scrollTop: $(this).offset().top - 65
                    }, 300);
                }
                // if there is no onsubmit, etc. function from attribute list maybe this isn't a Kentico form so submit it
                else {
                    $(this).off("submit").submit();
                }
            }
        });
    }

    function Input(input) {

        const field = input.parents("[data-zag-validate-field]");
        const errors = field.find("[data-zag-validate-errors]").show();

        // error handling for required across each input type
        const errorRequired = field.find(`[data-zag-validate-error=\"required\"]`);
        if (input.attr("data-zag-validate-input") == "text") {
            input.val() !== "" ? errorRequired.hide() : errorRequired.show();
        }
        else if (input.attr("data-zag-validate-input") == "check") {
            field.find("input[data-zag-validate-input=\"check\"]:checked").length !== 0 ? errorRequired.hide() : errorRequired.show();
        }
        else if (input.attr("data-zag-validate-input") == "upload") {
            input.val() !== "" ? errorRequired.hide() : errorRequired.show();
        }
        else if (input.attr("data-zag-validate-input") == "recaptcha") {
            var recaptchaResponse = field.find(".g-recaptcha-response").val();
            recaptchaResponse != "" ? errorRequired.hide() : errorRequired.show();
        }

        // error handling for maximum length validation (text field)
        const errorsMax = field.find(`[data-zag-validate-error=\"maximum\"]`);
        errorsMax.each(function () {
            input.val().length <= parseMaxMin($(this).attr("data-zag-validate-error-value")) ? $(this).hide() : $(this).show()
        });

        // error handling for minimum length validation (text field)
        const errorsMin = field.find(`[data-zag-validate-error=\"minimum\"]`);
        errorsMin.each(function () {
            input.val().length >= parseMaxMin($(this).attr("data-zag-validate-error-value")) ? $(this).hide() : $(this).show()
        });

        // error handling for regex validation (text field)
        const errorsRegex = field.find(`[data-zag-validate-error=\"regex\"]`);
        errorsRegex.each(function () {
            input.val().match($(this).attr("data-zag-validate-error-value")) ? $(this).hide() : $(this).show()
        });

        // count number of errors
        const errorCount = errors.children("[data-zag-validate-error]:visible").length;
        if (errorCount > 0) {
            field.attr("data-zag-validate-field", "error");
            errors.show();
        }
        else {
            field.attr("data-zag-validate-field", "");
            errors.hide();
        }
    }

    function parseMaxMin(str) {
        const num = parseFloat(str);
        return isNaN(num) ? 0 : num;
    }

    return {
        Init: Init
    };

})(jQuery);